import { render, staticRenderFns } from "./Ipi.vue?vue&type=template&id=3cb09bda&scoped=true&"
import script from "./Ipi.vue?vue&type=script&lang=js&"
export * from "./Ipi.vue?vue&type=script&lang=js&"
import style0 from "./Ipi.vue?vue&type=style&index=0&id=3cb09bda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb09bda",
  null
  
)

export default component.exports